import ActionButtonComponent from "@ui-components/ActionButtonComponent";
import ArrowDownTrayIcon from "@heroicons/react/24/solid/ArrowDownTrayIcon";
import BarsArrowDownIcon from "@heroicons/react/24/solid/BarsArrowDownIcon";
import {downloadZip} from "./FilesAndS3Utils";
import {prodGrouping} from "./constants";
import _ from "lodash";

export const buildProductsDocuments = (
	products,
	intl,
	apiRequest,
	productsDocumentsGrouping,
	setProductsDocumentsGrouping,
	search
) => {

	const prepareAndDownloadZip = async (docs) => {
		const promises = docs.map(async (document) => {
			let blob;
			try {
				const payload = {
					url: document.link,
					expected_content_type: "application/pdf",
				};
				blob = await apiRequest.post(`/products/document`, payload, {responseType: "blob"});
			} catch (e) {
				console.warn(`Error downloading document "${document.name}" - skipping`);
				console.warn(e);
				return;
			}
			return {filename: document.name + ".pdf", blob};
		})
		await downloadZip("products", await Promise.all(promises))
	}

	const getSchedaTecnicaName = (link) => {
		const splitted = link.split("/")
		return splitted[splitted.length - 1]
	}

	/*
	 * groupProductsBy groups the products documents by the selected grouping
	 * @param grouping: the grouping to use
	 * @return an object with the grouped documents
	 * this function is called every time the grouping changes
	 * can group by product or by document type.
	 */
	const groupProductsBy = (grouping) => {
		switch (grouping) {
			case prodGrouping.PRODUCT:
				return {
					title: intl.formatMessage({id: "technical_documents"}),
					alternateColor: "bg-gray-100",
					groups: products
						?.filter(p => p.link_scheda_tecnica)
						.map(product => {
							const productDocuments = [
								{
									name: getSchedaTecnicaName(product.link_scheda_tecnica),
									link: product.link_scheda_tecnica,
									onDocumentClicked: async () => {
										window.open(product.link_scheda_tecnica, "_blank")
									},
									visible: getSchedaTecnicaName(product.link_scheda_tecnica).toLowerCase().includes(search.toLowerCase()),
								},
							]
							if (product.link_video) {
								productDocuments.push({
									name: intl.formatMessage({id: "video"}),
									link: product.link_video,
									onDocumentClicked: async () => {
										window.open(product.link_video, "_blank")
									},
									visible: getSchedaTecnicaName(product.link_scheda_tecnica).toLowerCase().includes(search.toLowerCase()),
									selected: false
								})
							}
							return {
								key: "products",
								title: product.art_des_it,
								documents: productDocuments
							}
						}),
				}
			case prodGrouping.DOCUMENT_TYPE:
				return {
					title: intl.formatMessage({id: "technical_documents"}),
					alternateColor: "bg-gray-100",
					groups: [
						{
							key: "product_technical_sheet_list",
							title: _.capitalize(intl.formatMessage({id: "technical_sheets"})),
							documents: products?.filter(p => p.link_scheda_tecnica)
								.map(product => {
								return {
									name: getSchedaTecnicaName(product.link_scheda_tecnica),
									link: product.link_scheda_tecnica,
									onDocumentClicked: async () => {
										window.open(product.link_scheda_tecnica, "_blank")
									},
									visible: getSchedaTecnicaName(product.link_scheda_tecnica).toLowerCase().includes(search.toLowerCase())
								}
							})
						},
						{
							key: "product_video_list",
							title: _.capitalize(intl.formatMessage({id: "video"})),
							documents: products?.filter(p => p.link_video).map(product => {
								return {
									name: intl.formatMessage({id: "video"}),
									link: product.link_video,
									onDocumentClicked: async () => {
										window.open(product.link_video, "_blank")
									},
									visible: getSchedaTecnicaName(product.link_scheda_tecnica).toLowerCase().includes(search.toLowerCase())
								}
							})
						}
					]
				}
			default:
				throw new Error("Invalid grouping")
		}
	}


	return {
		...groupProductsBy(productsDocumentsGrouping), // the documents grouped by the selected grouping
		// the actions to show in the page
		actions: {
			download:	{
				// download all the documents as a zip
				actionComponent: (docs, visible) => <ActionButtonComponent
					icon={ArrowDownTrayIcon}
					action={async () => {
						await prepareAndDownloadZip(docs)
					}}
				/>
			},
			regroup:{
					// change the grouping of the documents
					actionComponent: (docs, visible) => <ActionButtonComponent
						icon={BarsArrowDownIcon}
						action={() => {
							if (productsDocumentsGrouping === prodGrouping.PRODUCT) {
								setProductsDocumentsGrouping(prodGrouping.DOCUMENT_TYPE)
							} else {
								setProductsDocumentsGrouping(prodGrouping.PRODUCT)
							}
						}}
					/>
				}
		}
	}
}